import { useTranslation, Trans } from 'react-i18next';
import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import { HiOfferBg, HiOfferBgExpire } from '@/assets/hi';
import { HiMessageLocal } from '../../../types';
import { formatOfferPrice, formatOfferPriceNumber } from '../../../utils';
import { secondsToMs } from '@/utils';
import styles from './index.module.css';
import cx from 'clsx';
import { HelperTooltip } from '@/components';

function formatOfferStatusText(offer: HiMessageLocal['offer']) {
  if (!offer) {
    return '';
  }

  switch (offer.status) {
    case 'charged':
      return '';
    case 'expired':
      return '';
    case 'uncharged':
      return (
        <Trans
          i18nKey="UnchargedMessageItem.uncharged"
          values={{ amount: dayjs(secondsToMs(offer.expired_at)).from(Date.now(), true) }}></Trans>
      );
  }
}

export default function UnchargedMessageItem({
  hiMessage,
  onCharge,
}: {
  hiMessage: HiMessageLocal;
  onCharge: () => void;
}) {
  const { t } = useTranslation();

  const isOfferUnCharged = hiMessage.offer?.status === 'uncharged';
  const validBounty = useMemo(
    () => isOfferUnCharged && Number(hiMessage?.offer?.bonus) > 0,
    [hiMessage?.offer?.bonus, isOfferUnCharged],
  );
  return (
    <div className={styles.messageItemWrapper}>
      <div className={styles.inner}>
        <div className={styles.envelopeBackground}>
          {isOfferUnCharged ? <HiOfferBg /> : <HiOfferBgExpire />}
        </div>
        <div className={styles.innerContent}>
          <HelperTooltip
            title={validBounty ? t('UnchargedMessageItem.addrBonus') : undefined}
            placement="right">
            <span
              className={cx([styles.priceText, isOfferUnCharged && styles.priceText_uncharged])}>
              {formatOfferPrice(hiMessage.offer, '$')}
              {hiMessage?.offer?.bonus ? (
                <span className={styles.bonusText}>{`+ ${formatOfferPriceNumber(
                  hiMessage?.offer?.bonus,
                  '$',
                )}`}</span>
              ) : null}
            </span>
          </HelperTooltip>

          <span className={styles.offerStatusText}>
            {isOfferUnCharged ? (
              <span className={styles.offerStatusTitle}>{t('UnchargedMessageItem.1aw0a72')}</span>
            ) : null}
            {formatOfferStatusText(hiMessage?.offer)}
          </span>

          <div className={styles.offerButton} onClick={evt => onCharge()} />
        </div>
      </div>
    </div>
  );
}
